import React from "react";
import Button from "components/UI/Button";
import axios from "axios";
import { API_URL, ERROR_HANDLE, urlify } from "config/constants";

class NoteEdit extends React.Component {
  updateNotes = () => {
    const access_token = localStorage.getItem("access_token");
    const gym_id = this.props.gym_id;
    let { gym_note } = this.state;

    const data = {
      gym_note
    };
    axios
      .put(`${API_URL}/admin/gyms/${gym_id}`, data, {
        headers: {
          "x-access-token": access_token
        }
      })

      .then(res => {
        console.log("Notes Saved");
        window.location.assign("/gyms/gym/notes");
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };
  render() {
    console.log(this.props.gym_id);
    return (
      <div style={style.wrapper}>
        <textarea
          style={style.textarea}
          onChange={e => {
            this.setState({ ...this.state, gym_note: e.target.value });
          }}
        />
        <Button
          style={style.button}
          holo
          onClick={() => {
            this.updateNotes();
          }}
        >
          Save
        </Button>
      </div>
    );
  }
}
export default NoteEdit;
const style = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: "10px",
    alignItems: "center"
  },
  button: {
    width: "150px",
    height: "61px",
    fontSize: "16px"
  },
  textarea: {
    margin: "25px",
    padding: "25px",
    height: "300px",
    width: "80%",
    border: "2px dashed #c6c6c6",
    borderRadius: "40px",
    fontSize: "16px"
  }
};
